import apiClient from "../../utils/interceptor"
import { ApiResponse, LoginParams, AuthResponse, ChangePasswordParams, ResetPasswordParams } from "./interface";
import { API_URLS } from "../../constants";
import { encryptAES } from "../../utils/crypto";


// Helper function to get auth token from localStorage
const getAuthToken = (): string | null => {
    return localStorage.getItem("auth_token");
};

// Login function
export const login = async (
    loginParams: LoginParams
): Promise<ApiResponse<AuthResponse>> => {
    try {
        const secretKey = "mySuperSecretKey1234567890123456";
        const encryptedData = await encryptAES(loginParams.password, secretKey);
        const loginPayloadParams = {user_name: loginParams.user_name, iv_hex:encryptedData.iv, encrypted_hex:encryptedData.encrypted  }
        const response = await apiClient.post<ApiResponse<AuthResponse>>(
            API_URLS.AUTH.LOGIN,
            loginPayloadParams
        );

        return response.data;
    } catch (error) {
        console.error("Error logging in:", error);
        throw error;
    }
};

// Change password function
export const changePassword = async (
    changePasswordParams: ChangePasswordParams
): Promise<ApiResponse<null>> => {
    const token = getAuthToken();

    try {
        const secretKey = "mySuperSecretKey1234567890123456";
        const oldEncryptedData = await encryptAES(changePasswordParams.old_password, secretKey);
        const changePasswordPayloadParams = {user_name: changePasswordParams.user_name, iv_hex_old:oldEncryptedData.iv, encrypted_hex_old: oldEncryptedData.encrypted, new_password: changePasswordParams.new_password }
        const response = await apiClient.post<ApiResponse<null>>(
            API_URLS.AUTH.CHANGE_PASSWORD,
            changePasswordPayloadParams,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error changing password:", error);
        throw error;
    }
};

// Reset password function
export const resetPassword = async (
    resetPasswordParams: ResetPasswordParams
): Promise<ApiResponse<null>> => {
    const token = getAuthToken();

    try {
        const response = await apiClient.post<ApiResponse<null>>(
            API_URLS.AUTH.RESET_PASSWORD,
            resetPasswordParams,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error resetting password:", error);
        throw error;
    }
};
